import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ResponsiveService } from '@immosky/object-search-layout';
import { Store } from '@ngrx/store';
import { AppState, ResponsiveTarget } from '@immosky/types';
import { LayoutService } from '../../services/layout.service';

@Component({
  selector: 'app-change-filter-card',
  templateUrl: './change-filter-card.component.html',
  styleUrls: ['./change-filter-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangeFilterCardComponent {
  constructor(
    private store: Store<AppState>,
    private responsiveService: ResponsiveService,
    private layoutService: LayoutService
  ) {}

  openFilters() {
    if (
      this.responsiveService.target(ResponsiveTarget.XS, ResponsiveTarget.MD)
    ) {
      this.layoutService.openMobileFilters();
    } else {
      window.scrollTo(0, 0);
    }
  }
}
